function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.9918 34.4125C37.9918 37.4775 36.2081 39.9644 34.0043 39.9644H11.1831C8.98059 39.9644 7.19434 37.4775 7.19434 34.4125V8.025C7.19434 4.96 8.98059 2.47375 11.1831 2.47375H34.0043C36.2081 2.47375 37.9918 4.96 37.9918 8.025V34.4125Z",
  fill: "#25333A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.7875 36.9938V16.2063V2.98755C35.7875 2.7063 35.5575 2.47192 35.2875 2.47192H3.23063C2.96063 2.47192 2.73438 2.7063 2.73438 2.98755V36.9938C2.73438 37.1457 2.78437 37.2632 2.86687 37.345C2.86687 37.3482 2.875 37.3507 2.88063 37.355C2.88063 37.3632 2.88625 37.365 2.89688 37.37C2.93935 37.4157 2.99111 37.4518 3.04867 37.4758C3.10624 37.4999 3.16827 37.5113 3.23063 37.5094H35.2875C35.5575 37.51 35.7875 37.2757 35.7875 36.9938Z",
  fill: "#FFFEFD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.63288 1.52057C9.68725 1.2587 10.6985 1.51932 11.0598 2.4712C11.1373 2.46745 12.7966 2.5262 12.7966 2.5262C12.4766 0.785572 10.5816 -0.147553 8.7585 0.0636975C6.34975 0.341822 5.51975 2.1887 5.68538 4.38682C5.75413 5.2962 7.15163 5.09807 7.08288 4.1937C6.98288 2.86745 7.21725 1.8737 8.63288 1.52057Z",
  fill: "#25333A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.0664 1.48627C18.1195 1.2244 19.1327 1.48502 19.492 2.4369C19.5708 2.43315 21.2295 2.4919 21.2295 2.4919C20.9083 0.751271 19.0152 -0.181854 17.1902 0.0293957C14.7814 0.307521 13.9514 2.1544 14.1183 4.35252C14.187 5.2619 15.5845 5.06377 15.5158 4.1594C15.4152 2.83252 15.6495 1.83877 17.0664 1.48627Z",
  fill: "#25333A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.9004 1.48627C27.9535 1.2244 28.9666 1.48502 29.326 2.4369C29.4048 2.43315 31.0641 2.4919 31.0641 2.4919C30.7429 0.751271 28.8491 -0.181854 27.0241 0.0293957C24.6154 0.307521 23.7854 2.1544 23.9523 4.35252C24.021 5.2619 25.4191 5.06377 25.3485 4.1594C25.2491 2.83252 25.4835 1.83877 26.9004 1.48627Z",
  fill: "#25333A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.325 12.9932H9.80004C8.62004 12.9932 8.62004 11.3369 9.80004 11.3369H27.325C28.5019 11.3363 28.5019 12.9932 27.325 12.9932Z",
  fill: "#35494D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.325 16.3563H9.80004C8.62004 16.3563 8.62004 14.7001 9.80004 14.7001H27.325C28.5019 14.7001 28.5019 16.3563 27.325 16.3563Z",
  fill: "#35494D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.325 19.7944H9.80004C8.62004 19.7944 8.62004 18.1382 9.80004 18.1382H27.325C28.5019 18.1382 28.5019 19.7944 27.325 19.7944Z",
  fill: "#35494D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.325 23.1563H9.80004C8.62004 23.1563 8.62004 21.4994 9.80004 21.4994H27.325C28.5019 21.4988 28.5019 23.1563 27.325 23.1563Z",
  fill: "#35494D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.3247 29.65H19.2597C18.0853 29.65 18.0853 27.9938 19.2597 27.9938H27.3247C28.5016 27.9931 28.5016 29.65 27.3247 29.65Z",
  fill: "#35494D"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
})));
function SvgSpiralNotepad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiralNotepad);
export default __webpack_public_path__ + "static/media/spiral-notepad.59fc923e.svg";
export { ForwardRef as ReactComponent };